import React, { useEffect, useRef, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { useDispatch, useSelector } from "react-redux";
import InActiveUser from "../../assets/svg/inactive-user.svg";
import PDFExport from "../../components/common/ui/Export/PDFExport";
import {
  authActions,
  inmateAction,
  masterActions,
  photoAction,
  publicUserActions,
} from "../../_store";
import {
  fDate,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
} from "../../utils/formatTime";
import CustomLoader from "../../components/common/ui/Loader";
import PendingIcon from "../../assets/svg/pending-user.svg";
import ApprovedIcon from "../../assets/svg/approved.svg";
import generateXlsx from "../../components/common/export/generateXlsx";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import inmatePhotosPDF from "../../components/common/export/inmatePhotosPDF";
import RejectIcon from "../../assets/svg/deactiveate-user.svg";
import Swal from "sweetalert2";
import generatePhoto_ListPDF from "../../components/common/export/Reports/generatePhoto_ListPDF";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";
import { getStoredValue } from "../../_helpers/storagehelper";
import generateMessageXlsx from "../../components/common/export/generateMessageXlsx";
import { useNavigate } from "react-router-dom";
import { handleDateRangeBlur } from "../../hooks/useDateRangeBlur";
import { handleDateInput } from "../../hooks/useDateInputHandler";

function PhotoList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );

  const { isPageReload: isPageReloading, isDashboardPage, isBacktoDashboard } = useSelector((state) => state.master);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const ActiveStatus = useSelector((x) => x?.dropdownOptions?.ActiveStatus);
  const userAccessPermission = useSelector(
    (state) => state.auth.managementUserAccessPermission
  );
  const user = useSelector((x) => x.auth.user);
  const { photosList, photosSearchData, photosSearch, loading } = useSelector(
    (x) => x?.photos
  );
  let sorting = false;
  const { accessPermission, InmateAccessPermission, PuAccessPermission } = useManagementUserAccessPermission();

  const [isLoading, setisLoading] = useState(false);

  const { isSignalRData } = useSelector((state) => state.auth);

  const paginationTriggered = useRef(false);

  const [errorMessage, setErrorMessage] = useState({
    photoSendStartDate: "",
    photoSendEndDate: ""
  });

  // Hide or Show Upload btn
  const ShowButtonApproveReject =
    Array?.isArray(accessPermission) && accessPermission?.length > 0
      ? accessPermission?.some(
        (item) => item?.SubMenuID === 23 && item?.SubMenuActiveStatus === 1
      ) // Review
      : true;

  /* photos list */
  useEffect(() => {
    if (commonFacilityCode === 0) return;
    const searchData = { ...photosSearchData };
    searchData.facilityID = commonFacilityCode;
    if (isDashboardPage) {
      searchData.pageNo = 1;
      searchData.photoSendStartDate = "01/01/2017";
      searchData.rowCountPerPage = 10;
    }
    dispatch(photoAction?.setPhotosSearch(searchData));
    setisLoading(true);
    dispatch(photoAction?.getPhotosList(searchData))
      .then((result) => {
        // if (result?.payload?.DataList?.length === 0) {
        //   const searchData = { ...photosSearchData };
        //   searchData.facilityID = commonFacilityCode;
        //   searchData.pageNo = 1;
        //   dispatch(photoAction?.setPhotosSearch(searchData));
        //   dispatch(photoAction?.getPhotosList(searchData)).then((x => {
        //     setisLoading(false);
        //   }))
        // }
        // else {
        setisLoading(false);
        //   }
      })
      .catch((err) => { });
  }, [
    photosSearchData.sortBy,
    commonFacilityCode,
    isPageReloading,
    isDashboardPage
  ]);

  // const handlephotoList = () => {
  //   const searchData = { ...photosSearchData };
  //   searchData.facilityID = commonFacilityCode;
  //   searchData.isNoLoading = true;
  //   dispatch(photoAction?.getPhotosList(searchData))
  // }

  //signalR
  // useEffect(() => {
  //   switch (isSignalRData?.type) {
  //     case 'Send_Photo':
  //       handlephotoList();
  //       break;
  //     case 'Reject_Photo':
  //     case 'Approve_Photo':
  //       if (isSignalRData?.user !== user?.ManagementUserID)
  //         handlephotoList();
  //       break;
  //   }
  // }, [isSignalRData]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const findGraphemeClusters = (input, returninput) => {
    const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
    if (returninput)
      return (
        Array.from(segmenter.segment(input))
          .slice(0, 15)
          .map((item) => item.segment)
          .join("") + "..."
      );
    else return Array.from(segmenter.segment(input));
  };

  const columns = [
    {
      width: "210px",
      name: "Subject",
      key: "PhotoSubject",
      selector: (row) => row.PhotoSubject,
      cell: (row) => (
        <div className="d-flex flex-wrap gap-2 align-items-start">
          <div
            //title={row.PhotoSubject}
            onClick={() => navigateToPhotoInfo(row.PhotoCommID)}
            className={` ${accessPermission[0]?.SubMenuActiveStatus !== 0
              ? "Common_Link_Style"
              : ""
              }`}
          >
            {findGraphemeClusters(row.PhotoSubject, false)?.length > 15
              ? findGraphemeClusters(row.PhotoSubject, true)
              : row.PhotoSubject}
          </div>
          {row?.UserPhotoReadStatus === 0 && (
            <div className="newbutton-container">
              New
              <div className="border-animation"></div>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      width: "210px",
      name: "From",
      key: "PhotoFrom",
      selector: (row) => row.PhotoFrom,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div className="user-batch button-success"></div>
          <div
            className={` ${PuAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""}`}
            onClick={() => handleNavigatePublicInfo(row)}
          >
            {row.PhotoFrom}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "210px",
      name: "To",
      key: "PhotoTo",
      selector: (row) => row.PhotoTo,
      sortable: true,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div className="user-batch button-primary"></div>
          <div
            className={` ${(InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : ""}`}
            onClick={() => handleNavigateInmateInfo(row)}
          >
            {row.PhotoTo}
          </div>
        </div>
      ),
    },

    {
      width: "120px",
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
      cell: (row) => (
        <div
          className={` ${(InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : ""}`}
          onClick={() => handleNavigateInmateInfoID(row)}
        >
          {row.InmateResidentId}
        </div>
      ),
    },

    {
      width: "170px",
      name: "Photo Cost($)",
      key: "PhotoCost",
      selector: (row) => row.PhotoCost?.toFixed(2),
      sortable: true,
    },
    {
      width: "180px",
      name: "Sent On",
      key: "PhotoSentDate",
      selector: (row) => row.PhotoSentDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDate(row?.PhotoSentDate)}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "PhotoActionStatus",
      selector: (row) => row.PhotoActionStatus,
      cell: (row) =>
        row.PhotoActionStatus === "Pending" ? (
          <img
            src={PendingIcon}
            alt="pending-status"
            title="Pending"
            className="in-icon-size"
          />
        ) : row.PhotoActionStatus === "Approved" ? (
          <img
            src={ApprovedIcon}
            alt="approved-status"
            title="Approved"
            className="in-icon-size"
          />
        ) : (
          <img
            src={RejectIcon}
            title="Rejected"
            alt="inactive-status"
            className="in-icon-size"
          />
        ),
      sortable: true,
    },
  ];

  const navigateToPhotoInfo = (id) => {
    Swal?.close();
    dispatch(masterActions.UpdateisDashboardPage(false));
    if (accessPermission[0]?.SubMenuActiveStatus === 0) return;
    dispatch(photoAction?.resetForm());
    history.navigate("/Admin/PhotoList/info", {
      state: { photoCommID: id, source: "photoList" },
    });
  };

  const handleNavigatePublicInfo = (row) => {
    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    Swal?.close();
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "photos" },
    });
  };

  const handleNavigateInmateInfo = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0 || user?.UserRoleID == 13) return;
    Swal?.close();
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));

    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "photos", showTransactionTab: false },
    });
  };
  const handleNavigateInmateInfoID = (row) => {

    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0 || user?.UserRoleID == 13) return;
    Swal?.close();
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));

    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "photos", showTransactionTab: false },
    });
  };

  const handleRowPerPage = (page) => {
    const updateSearch = { ...photosSearchData };
    updateSearch.rowCountPerPage = page;
    updateSearch.pageNo = 1;
    updateSearch.facilityID = commonFacilityCode;
    dispatch(photoAction?.setPhotosSearch(updateSearch));
    dispatch(photoAction?.getPhotosList(updateSearch)).then((x => {
      setisLoading(false);
    }))
  };

  const handlePageChange = (page) => {
    if (paginationTriggered.current) {
      paginationTriggered.current = false;
      return;
    }

    if (sorting) {
      sorting = false;
      return;
    }
    const updateSearch = { ...photosSearchData };
    updateSearch.pageNo = page;
    updateSearch.facilityID = commonFacilityCode;
    dispatch(photoAction?.setPhotosSearch(updateSearch));
    dispatch(photoAction?.getPhotosList(updateSearch)).then((x => {
      setisLoading(false);
    }))
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...photosSearchData };
    const newSortOrder = search.sortBy?.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    dispatch(photoAction?.setPhotosSearch(search));
  };

  const handleChange = (e, input) => {
    const updateSearch = {
      ...photosSearchData,
      pageNo: 1,
      rowCountPerPage: 10,
    };
    paginationTriggered.current = true
    if (input) {
      if (input === "photoActionStatus") {
        updateSearch[input] = e?.value || 3;
        dispatch(photoAction?.setPhotosSearch(updateSearch));
        const isvalid = handlechecksearchDate();
        if (!isvalid)
          return;
        dispatch(photoAction?.getPhotosList(updateSearch));
        return;
      } else {
        let formattedDate = fDate(e);
        updateSearch[input] = formattedDate;
        dispatch(photoAction?.setPhotosSearch(updateSearch));
        // setPhotosSearch({ ...photosSearchData, [input]: formattedDate });
        return;
      }
    }
    const { name, value } = e?.target;
    if (name === "inmateResidentId") {
      const regex = /^[0-9\s]*$/;
      if (!regex.test(value)) return;
    }
    updateSearch[name] = value;
    dispatch(photoAction?.setPhotosSearch(updateSearch));
    setErrorMessage({});
    // setPhotosSearch({ ...photosSearchData, [name]: value });
  };

  const handleDateEnterKey = (event, name) => {
    handleDateInput({
      event,
      name,
      minDate: new Date(2017, 0, 1),
      maxDate: new Date(),
      onBlur: handleDateRangeBlur,
    });
  };



  const handleDateBlur = (e, fieldName, manualValue) => {
    const value = manualValue || e.target.value;

    const updatedParam = handleDateRangeBlur({
      value,
      fieldName,
      startKey: "photoSendStartDate",
      endKey: "photoSendEndDate",
      searchdata: photosSearchData,
      setErrorMessage,
      monthrange: 6
    });

    dispatch(photoAction.setPhotosSearch(updatedParam));
  };

  const handleSearchReset = () => {
    setErrorMessage({});
    paginationTriggered.current = false;
    const resetSearch = {
      facilityID: commonFacilityCode,
      inmateResidentId: "",
      publicFirstName: "",
      publicLastName: "",
      inmateFirstName: "",
      inmateLastName: "",
      photoSubject: "",
      photoSendStartDate: getPastDate(1),
      photoSendEndDate: getCurrentDate(),
      photoActionStatus: 3,
      managementUserID: getStoredValue("user")
        ?.ManagementUserID,
      pageNo: 1,
      rowCountPerPage: 10,
      sortBy: "",
      exportExcel: false,
      exportPDF: false,
    };
    dispatch(photoAction?.setPhotosSearch(resetSearch));
    // setPhotosSearch(resetSearch);
    dispatch(photoAction?.getPhotosList(resetSearch));
  };

  const exportDocAsExcel = () => {
    let generateExcelColumns = [
      "Subject",
      "From",
      "To",
      "Inmate ID",
      "Photo Cost($)",
      "Sent On",
      "Status",
    ];

    const updateTotalRows = {
      ...photosSearchData,
      rowCountPerPage: photosList?.TotalRecordCount,
      pageNo: 1,
      exportExcel: true,
    };
    dispatch(photoAction?.getPhotosList(updateTotalRows))
      .then((result) => {
        const dataList = result?.payload?.DataList;
        let exportData =
          result &&
          dataList?.map((obj) => ({
            Subject: obj.PhotoSubject,
            From: obj.PhotoFrom,
            To: obj.PhotoTo,
            "Inmate ID": obj.InmateResidentId,
            "Photo Cost($)": obj?.PhotoCost?.toFixed(2),
            "Sent On": obj.PhotoSentDate,
            Status: obj.PhotoActionStatus,
          }));
        generateMessageXlsx(exportData, generateExcelColumns, "Photos_List");
      })
      .catch((err) => {
        showToastNotification("Error in Export Data", "error");
      });
  };

  const exportDocAsPDF = () => {
    // const exportData = photosList?.DataList?.map((item) => ({
    //   InmateName: "White Shameka",
    //   InmateID: "13271",
    //   Subject: item?.PhotoSubject,
    //   From: item?.PhotoFrom,
    //   PhotoCost: item?.PhotoCost?.toFixed(2),
    //   SendDate: item?.PhotoSentDate,
    //   Status: item?.PhotoActionStatus,
    //   FacilityName: item?.FacilityCode,
    //   PhotoBinaryData: "data:image;base64," + item?.PhotoBinaryData,
    // }));
    // return;

    // inmatePhotosPDF("", exportData, "Message Conversation");
    const updateTotalRows = {
      ...photosSearchData,
      rowCountPerPage: photosList?.TotalRecordCount,
      pageNo: 1,
      exportExcel: true,
    };
    setisLoading(true);
    dispatch(photoAction?.getPhotosListDownload(updateTotalRows)).then((result) => {
      const photosList = result?.payload;
      setisLoading(false);
      // const inmateId = photosList?.DataList[0]?.InmateResidentId;
      // const inmateName = photosList?.DataList[0]?.PhotoTo;
      const title = "Inmate_Photos_Communication";

      const photoDetails = photosList?.DataList?.map((obj) => ({
        InmateId: obj?.InmateResidentId,
        InmateName: obj?.PhotoTo,
        Subject: obj?.PhotoSubject || "N/A",
        From: obj?.PhotoFrom || "N/A",
        PhotoCost: obj?.PhotoCost?.toFixed(2) || "N/A",
        SendDate: obj?.PhotoSentDate || "N/A",
        Status: obj?.PhotoActionStatus || "N/A",
        FacilityName: obj?.FacilityCode || "N/A",
        base64: obj?.PhotoBinaryData || obj?.PhotoAttachPath || "N/A",
      }));

      generatePhoto_ListPDF(photoDetails, title);
    });
  };

  const handlechecksearchDate = () => {
    const { photoSendStartDate, photoSendEndDate } = photosSearchData;
    if (!photoSendStartDate || !photoSendEndDate) {
      setErrorMessage({
        photoSendStartDate: !photoSendStartDate ? "Please select From Date." : "",
        photoSendEndDate: !photoSendEndDate ? "Please select To Date." : "",
      });
      return false;
    }
    return true
  }

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const isvalid = handlechecksearchDate();
    if (!isvalid)
      return;

    paginationTriggered.current = false
    const search = { ...photosSearchData, pageNo: 1, rowCountPerPage: 10 };
    dispatch(photoAction.setPhotosSearch(search));
    setisLoading(true);
    dispatch(photoAction?.getPhotosList(search)).then((x) => { setisLoading(false) });
  };

  const handleReviewPhotos = () => {
    if (
      photosSearchData.photoActionStatus === 1 ||
      photosSearchData.photoActionStatus === 2
    ) {
      // const inactiveinmate = photosList?.DataList?.filter((item) => item?.InmateStatus !== 1);
      Popup({
        title: "Message",
        text: `There were no photos in pending status.`,
        icon: "info",
        confirmButtonText: "Ok",
        //  note: inactiveinmate?.length == 0 ? null : `Inactive inmates with pending photos are excluded from the "Review Photos". Please check and reject them from the main photo grid.`,
      });
      return;
    }

    const search = {
      ...photosSearchData,
      pageNo: 1,
      rowCountPerPage: photosList?.TotalRecordCount,
      photoActionStatus: 3,
      isReviewPhotos: true,
    };

    dispatch(photoAction?.LoadReviewALLPhotosList(search)).then((result) => {
      const photoCount = result?.payload?.TotalRecordCount;
      const reviewData = result?.payload?.DataList;

      // history.navigate("/Admin/PhotoList/info", {
      //   state: {
      //     name: "ReviewPhotos",
      //     searchList: photosSearchData,
      //     source: "photoList",
      //   },
      // });

      if (photoCount > 0) {
        history.navigate("/Admin/PhotoList/info", {
          state: {
            name: "ReviewPhotos",
            searchList: reviewData,
            source: "photoList",
          },
        });

        const shouldEnableBtn =
          Array.isArray(accessPermission) && accessPermission?.length > 0
            ? accessPermission?.some(
              (item) =>
                item?.SubMenuName === "Review" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableBtn) {
          showToastNotification(
            "Review option has been disabled by the admin.",
            "error"
          );
          return;
        }
        dispatch(photoAction?.resetForm());
      } else {
        const inactiveinmate = photosList?.DataList?.filter((item) => item?.InmateStatus !== 1 && item?.PhotoActionStatus == "Pending");
        Popup({
          title: "Message",
          text: `There were no photos in pending status.`,
          icon: "info",
          confirmButtonText: "Ok",
          note: inactiveinmate?.length == 0 ? null : `Inactive inmates with pending photos are excluded from the "Review Photos". Please check and reject them from the main photo grid.`,
        });
        return;
      }
    });
  };

  const handleMultiplePhotosReview = () => {
    if (
      photosSearchData.photoActionStatus === 1 ||
      photosSearchData.photoActionStatus === 2
    ) {
      //const inactiveinmate = photosList?.DataList?.filter((item) => item?.InmateStatus !== 1);
      Popup({
        title: "Message",
        text: `There were no photos in pending status.`,
        icon: "info",
        confirmButtonText: "Ok",
        //note: inactiveinmate?.length == 0 ? null : `Inactive inmates with pending photos are excluded from the "Multi-Photos Review". Please check and reject them from the main photo grid.`,
      });
      return;
    }
    setisLoading(true);
    const search = {
      ...photosSearchData,
      pageNo: 1,
      // rowCountPerPage: photosList?.TotalRecordCount,
      rowCountPerPage: 12,
      photoActionStatus: 3,
      isReviewPhotos: true,
      source: "photoList",
      isPageRefresh: false,
    };

    //dispatch(photoAction?.setPhotosSearch(search));
    dispatch(photoAction?.setmultiPhotosSearch(search));
    dispatch(photoAction?.LoadReviewALLPhotosListNew(search)).then((result) => {
      const photoCount = result?.payload?.TotalRecordCount;
      const reviewData = result?.payload?.DataList;

      // history.navigate("/Admin/PhotoList/info", {
      //   state: {
      //     name: "ReviewPhotos",
      //     searchList: photosSearchData,
      //     source: "photoList",
      //   },
      // });

      if (photoCount > 0) {
        dispatch(photoAction?.setmultiplePhotoStateList(reviewData));
        history.navigate("/Admin/PhotoList/MultiplePhotosReview", {
          state: {
            name: "ReviewPhotos",
            //searchList: reviewData.slice(0, 1),

            // source: "photoList",
          },
        });
        setisLoading(false);
        const shouldEnableBtn =
          Array.isArray(accessPermission) && accessPermission?.length > 0
            ? accessPermission?.some(
              (item) =>
                item?.SubMenuName === "Review" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableBtn) {
          showToastNotification(
            "Review option has been disabled by the admin.",
            "error"
          );
          return;
        }
        dispatch(photoAction?.resetForm());
      }
      else {
        setisLoading(false);
        const inactiveinmate = photosList?.DataList?.filter((item) => item?.InmateStatus !== 1 && item?.PhotoActionStatus == "Pending");
        Popup({
          title: "Message",
          text: `There were no photos in pending status.`,
          icon: "info",
          confirmButtonText: "Ok",
          note: inactiveinmate?.length == 0 ? null : `Inactive inmates with pending photos are excluded from the "Multi-Photos Review". Please check and reject them from the main photo grid.`,
        });
        return;
      }
    });
  };

  if (loading || isLoading) return <CustomLoader />;

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleBack = () => {
    navigate("/Admin/Dashboard");
  }


  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateResidentId"
                id="inmateResidentId"
                label="Inmate ID"
                value={photosSearchData?.inmateResidentId}
                handleChange={handleChange}
                placeholder="Enter Inmate ID"
                maxLength={25}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateLastName"
                id="inmateLastName"
                label="Inmate Last Name"
                value={photosSearchData?.inmateLastName}
                handleChange={handleChange}
                placeholder="Enter Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateFirstName"
                id="inmateFirstName"
                label="Inmate First Name"
                value={photosSearchData?.inmateFirstName}
                handleChange={handleChange}
                placeholder="Enter First Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="photoSubject"
                id="photoSubject"
                label="Subject"
                value={photosSearchData?.photoSubject}
                handleChange={handleChange}
                placeholder="Enter Subject"
              // maxLength={25}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="publicLastName"
                id="publicLastName"
                label="Public User Last Name"
                value={photosSearchData?.publicLastName}
                handleChange={handleChange}
                placeholder="Enter Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="publicFirstName"
                id="publicFirstName"
                label="Public User First Name"
                value={photosSearchData?.publicFirstName}
                handleChange={handleChange}
                placeholder="Enter First Name"
                required={false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                name="photoSendStartDate"
                label="From Date"
                value={photosSearchData?.photoSendStartDate}
                handleChange={(e) => handleChange(e, "photoSendStartDate")}
                minDate={new Date(2017, 0, 1)}
                maxDate={
                  photosSearchData?.photoSendEndDate
                    ? photosSearchData?.photoSendEndDate
                    : new Date()
                }
                //isClearable={false}
                isClearable={false}
                preventClear={false}
                handleBlur={(e) => handleDateBlur(e, "photoSendStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "photoSendStartDate")
                }
                errorMessage={photosSearchData?.photoSendStartDate ? {} : errorMessage}
                required={true}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                required={true}
                name="photoSendEndDate"
                label="To Date"
                value={photosSearchData?.photoSendEndDate}
                handleChange={(e) => handleChange(e, "photoSendEndDate")}
                maxDate={
                  photosSearchData?.photoSendStartDate !== ""
                    ? new Date(
                      Math.min(
                        new Date(photosSearchData?.photoSendStartDate).setMonth(
                          new Date(photosSearchData?.photoSendStartDate).getMonth() + 6
                        ), // 6 months after fromDate
                        new Date() // Current date
                      )
                    )
                    : new Date()
                }
                minDate={photosSearchData?.photoSendStartDate ? photosSearchData?.photoSendStartDate : new Date(2017, 0, 1)}
                // minDate={
                //   photosSearchData?.photoSendStartDate || new Date(2017, 0, 1)
                // }
                // isClearable={false}
                isClearable={false}
                preventClear={false}
                handleBlur={(e) => handleDateBlur(e, "photoSendEndDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "photoSendEndDate")}
                errorMessage={photosSearchData?.photoSendEndDate ? {} : errorMessage}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="photoActionStatus"
                options={ActiveStatus}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={photosSearchData?.photoActionStatus !== 3}
                label="Status"
                placeholder="Select Status"
                value={photosSearchData?.photoActionStatus}
                handleChange={(e) => handleChange(e, "photoActionStatus")}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <>
      {commonFacilityCode > 0 ? (
        <div className="photos">
          <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">

              {/* Mobile Only */}
              {isBacktoDashboard && (
                <div className="d-block d-md-none card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
                  <div className="d-flex justify-content-end">
                    <Button
                      label="BACK To DashBoard"
                      type="button"
                      className="me-2"
                      onClick={() => handleBack()}
                      variant="danger"
                      status={"primary"}
                      icon={"fa-solid fa-angle-left"}
                      disabled={false}
                    />
                  </div>
                </div>
              )}

              {/* Mobile only (Below md breakpoint) */}
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    PHOTO SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none mt-2">
                {showSearchFields && renderSearch()}
              </div>

              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space ">
                  <h2 className="form_title_uppercase text-color">
                    PHOTO SEARCH
                  </h2>
                  {isBacktoDashboard && (
                    <div className="d-flex flex-wrap gap-3">
                      <Button
                        label="BACK To DashBoard"
                        type="button"
                        className=" me-2"
                        onClick={() => handleBack()}
                        variant="danger"
                        status={"primary"}
                        icon={"fa-solid fa-angle-left"}
                        disabled={false}
                      />
                    </div>
                  )}
                </div>

              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>
            </div>

            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
              <div className="d-flex flex-wrap justify-content-between align-items-center ">
                <h2 className="text-color">PHOTOS LIST</h2>
                {photosList?.DataList?.length > 0 && (
                  <div className="d-flex flex-wrap  align-items-center gap-3">
                    {ShowButtonApproveReject && (
                      <>
                        <Button
                          variant="success"
                          onClick={() =>
                            handleReviewPhotos(photosList?.DataList?.[0])
                          }
                          label="Review Photos Here"
                          type="button"
                          icon={"fas fa-images"}
                          status="btn-label"
                          disabled={false}
                        />
                      </>
                    )}
                    {ShowButtonApproveReject && (
                      <>
                        <Button
                          variant="success"
                          onClick={() => handleMultiplePhotosReview()}
                          label="Multi-Photos Review"
                          type="button"
                          icon={"fas fa-images"}
                          status="btn-label"
                          disabled={false}
                        />
                      </>
                    )}
                    <PDFExport
                      handlePDFExport={exportDocAsPDF}
                      className="btn btn-primary me-2"
                    />
                    <ExcelExport handleExcelExport={exportDocAsExcel} />
                  </div>
                )}
              </div>
              {photosList?.DataList?.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-1">
                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <div className="user-batch button-success"></div>
                    <div className="text fs-5">Public Users</div>
                  </div>

                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <div className="user-batch button-primary"></div>
                    <div className="text fs-5">Inmates</div>
                  </div>
                </div>
              )}

              <Table
                columns={columns}
                data={photosList?.DataList}
                pagination
                onChangeRowsPerPage={handleRowPerPage}
                onChangePage={handlePageChange}
                totalRowCount={photosList?.TotalRecordCount}
                currentPage={photosSearchData?.pageNo}
                paginationPerPage={photosSearchData.rowCountPerPage}
                onSort={handleSort}
                serverSideSort
                sortColumn={photosSearchData?.sortBy?.split(" ")[0]}
                sortDirection={photosSearchData?.sortBy?.split(" ")[1]}
              />
            </div>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </>
  );
}

export default React.memo(PhotoList);
